import { defaultModel } from "../core/chat/openai";
import { OptionGroup } from "../core/options/option-group";

export const parameterOptions: OptionGroup = {
    id: 'parameters',
    options: [
        {
            id: "model",
            defaultValue: defaultModel,
            resettable: true,
            scope: "user",
            displayOnSettingsScreen: "chat",
            displayAsSeparateSection: true,
            // Quick settings removed
            renderProps: (value, options, context) => ({
                type: "select",
                label: "Model",
                description: "",
                options: [
                    {
                        label: "Based 1",
                        value: "based1",
                    },
                    {
                        label: "Based 2",
                        value: "based2",
                    },
                    {
                        label: "Based 3",
                        value: "based3",
                    },

                ],
            }),
        },
        {
            id: "personality",
            defaultValue: "formal",
            resettable: true,
            scope: "user",
            displayOnSettingsScreen: "chat",
            displayAsSeparateSection: true,
            renderProps: (value, options, context) => ({
                type: "select",
                label: "Personality",
                description: "",
                options: [
                    {
                        label: "Chill",
                        value: "chill",
                    },
                    {
                        label: "Formal",
                        value: "formal",
                    },
                ],
            }),
        },
        {
            id: "extreme",
            defaultValue: true,
            resettable: true,
            scope: "user",
            displayOnSettingsScreen: "chat",
            displayAsSeparateSection: true,
            renderProps: (value, options, context) => ({
                type: "checkbox",
                label: "Politically Extreme",
                description: "",
            }),
        },
        // Temperature is now hardcoded - removed from options
    ]
};

// Tools option group
export const toolsOptions: OptionGroup = {
    id: 'tools',
    name: 'Tools',
    options: [
        {
            id: "webSearch",
            defaultValue: false,
            resettable: true,
            scope: "user",
            displayOnSettingsScreen: "chat",
            displayAsSeparateSection: false,
            renderProps: (value, options, context) => ({
                type: "checkbox",
                label: "Web Search",
                description: "Enable web search capabilities for your queries",
            }),
        },
    ]
};
